import { render } from "./OtiClock.vue?vue&type=template&id=07a3b53e&scoped=true"
import script from "./OtiClock.vue?vue&type=script&lang=js"
export * from "./OtiClock.vue?vue&type=script&lang=js"

import "./OtiClock.vue?vue&type=style&index=0&id=07a3b53e&lang=scss&scoped=true"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a3b53e"]])

export default __exports__